require('./aclService');
require('./contentConfigServices/contentTypeConfigService');
require('./contentConfigServices/contentTypeGroupConfigService');
require('./contentConfigServices/contentTypeGroupTagTypeConfigService');
require('./contentConfigServices/contentTypeTagTypeConfigService');
require('./contentConfigServices/statusConfigService');
require('./contentSearchService');
require('./contentTypeAcls');
require('./contentTypeGroupsSearchService');
require('./contentTypeGroupsService');
require('./contentTypesSearchService');
require('./contentTypesService');
require('./contentUploadService');
require('./deleteDialogService/deleteDialog.template');
require('./deleteDialogService/deleteDialogService');
require('./deletedItemsService');
require('./documentHistoryService');
require('./documentNotesService');
require('./documentViewerNavigationService');
require('./environmentService');
require('./iconService');
require('./indexTypesDataTypes');
require('./indexTypesService');
require('./libraryConfigService');
require('./sortService');
require('./statusService');
require('./toDoListService');
require('./toolbarService');
require('./userGroupFilterService');


//////////////////
// WEBPACK FOOTER
// ./app/services/index.js
// module id = 154
// module chunks = 1